import { ArtifactChoice } from '@dreamai/types';

// Local extension until the rail choice payload is published in dream-types.
export interface RailOffer {
  offerId: string;
  bookingMode: 'prepare';
  price: number;
  currency: string;
  conditions: string[];
  conditionsSummary: string;
}

export type RailArtifactChoice = ArtifactChoice & {
  railOffer?: RailOffer | null;
};

// Only a complete selection of backend-marked fares can skip spending approval.
export function areDreamRailChoices(
  choices: ArtifactChoice[],
  selectedChoiceIds: string[],
): boolean {
  return (
    selectedChoiceIds.length > 0 &&
    selectedChoiceIds.every((id) => {
      const choice = choices.find((c) => c.choiceId === id) as
        | RailArtifactChoice
        | undefined;
      const offer = choice?.railOffer;
      return (
        offer?.bookingMode === 'prepare' &&
        typeof offer.offerId === 'string' &&
        offer.offerId.trim().length > 0
      );
    })
  );
}
